import angular from 'angular'

import { defaultTo, isAllDefined } from '../utils/bits'
import { has, wrap, assign, isString } from 'lodash-es'

angular
  .module('ggs.animate')
  .factory('animateApplyInternal', AnimateApplyInternalProvider)
  .directive('ggsAnimateShow', AnimateShowDirective)
  .directive('ggsAnimateHide', AnimateHideDirective)

function AnimateApplyInternalProvider(animate) {
  const defaultConfig = {
    transitionShow: null,
    transitionHide: null,
    transition: null,
    showForce: false,
    hideForce: false,
    showSoft: false,
    hideSoft: false
  }

  return function animateApplyInternal($elm, config, show) {
    const sumConfig = assign({}, defaultConfig, config)
    const showArg = { $elm, transition: defaultTo(sumConfig.transitionShow, sumConfig.transition) }
    const hideArg = { $elm, transition: defaultTo(sumConfig.transitionHide, sumConfig.transition) }

    if (show) {
      if (sumConfig.showForce) {
        return animate.showForce(showArg)
      } else if (sumConfig.showSoft) {
        return animate.showSoft(showArg)
      } else {
        return animate.show(showArg)
      }
    } else if (sumConfig.hideForce) {
      return animate.hideForce(hideArg)
    } else if (sumConfig.hideSoft) {
      return animate.hideSoft(hideArg)
    } else {
      return animate.hide(hideArg)
    }
  }
}

function AnimateShowDirective($log, $parse, animate, animateApplyInternal) {
  return {
    restrict: 'A',
    link: realLink
  }

  function realLink($scope, $elm, $attr) {
    const config = $scope.$eval($attr.ggsAnimateShowConfig)
    const onInit = $scope.$eval($attr.ggsAnimateShowOnInit)
    const ngExp = $parse($attr.ggsAnimateShow)
    const init = ngExp($scope)

    if (isString(onInit) && has(animate, onInit)) {
      animate[onInit]($elm)
    }

    if (isAllDefined(init) && ngExp.oneTime) {
      handler(init)
    } else {
      $scope.$watch(ngExp, handler)
    }

    function handler(show) {
      animateApplyInternal($elm, config, show).catch(wrap('animateShow: problem in the animate module:', $log.error))
    }
  }
}

function AnimateHideDirective($log, $parse, animate, animateApplyInternal) {
  return {
    restrict: 'A',
    link: realLink
  }

  function realLink($scope, $elm, $attr) {
    const config = $scope.$eval($attr.ggsAnimateHideConfig)
    const onInit = $scope.$eval($attr.ggsAnimateHideOnInit)
    const ngExp = $parse($attr.ggsAnimateHide)
    const init = ngExp($scope)

    if (isString(onInit) && has(animate, onInit)) {
      animate[onInit]($elm)
    }

    if (isAllDefined(init) && ngExp.oneTime) {
      handler(init)
    } else {
      $scope.$watch(ngExp, handler)
    }

    function handler(hide) {
      animateApplyInternal($elm, config, !hide).catch(wrap('animateHide: problem in the animate module:', $log.error))
    }
  }
}
